module.exports = __webpack_public_path__ + "img/mlc.e43663fd.jpg";